<template>
  <SiteSection
    sectionId="section-talking"
    sectionNo="3"
    label="歷屆實習生分享"
    title="SPROUTERS' TALKING"
  >
    <div class="label-container">
      <GenerationLabel
        labelName="2024"
        :isActive="isActive(2024)"
        @click.native="changeGeneration(2024)"
      />
      <GenerationLabel
        labelName="2023"
        :isActive="isActive(2023)"
        @click.native="changeGeneration(2023)"
      />
      <GenerationLabel
        labelName="2022"
        :isActive="isActive(2022)"
        @click.native="changeGeneration(2022)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2021"
        :isActive="isActive(2021)"
        @click.native="changeGeneration(2021)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2020"
        :isActive="isActive(2020)"
        @click.native="changeGeneration(2020)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2019"
        :isActive="isActive(2019)"
        @click.native="changeGeneration(2019)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2018"
        :isActive="isActive(2018)"
        @click.native="changeGeneration(2018)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2017"
        :isActive="isActive(2017)"
        @click.native="changeGeneration(2017)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2016"
        :isActive="isActive(2016)"
        @click.native="changeGeneration(2016)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2015"
        :isActive="isActive(2015)"
        @click.native="changeGeneration(2015)"
      >
      </GenerationLabel>
      <GenerationLabel
        labelName="2014"
        :isActive="isActive(2014)"
        @click.native="changeGeneration(2014)"
      >
      </GenerationLabel>
    </div>
    <Generation 
    :sprouters="sprouters.sprouters2024" :activeGeneration="activeGeneration" 
    v-if="activeGeneration === 2024"
    />
    <Generation
      :sprouters="sprouters.sprouters2023"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2023"
    />
    <Generation
      :sprouters="sprouters.sprouters2022"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2022"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2021"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2021"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2020"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2020"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2019"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2019"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2018"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2018"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2017"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2017"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2016"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2016"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2015"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2015"
    >
    </Generation>
    <Generation
      :sprouters="sprouters.sprouters2014"
      :activeGeneration="activeGeneration"
      v-if="activeGeneration == 2014"
    >
    </Generation>
  </SiteSection>
</template>

<script>
import SiteSection from "./source/Section.vue";
import GenerationLabel from "./sectionTalking/Label.vue";
import Generation from "./sectionTalking/Generation.vue";

import sprouters2024 from "../models/Sprouters2024.js";
import sprouters2023 from "../models/Sprouters2023.js";
import sprouters2022 from "../models/Sprouters2022.js";
import sprouters2021 from "../models/Sprouters2021.js";
import sprouters2020 from "../models/Sprouters2020.js";
import sprouters2019 from "../models/Sprouters2019.js";
import sprouters2018 from "../models/Sprouters2018.js";
import sprouters2017 from "../models/Sprouters2017.js";
import sprouters2016 from "../models/Sprouters2016.js";
import sprouters2015 from "../models/Sprouters2015.js";
import sprouters2014 from "../models/Sprouters2014.js";

export default {
  name: "SectionTalking",
  components: {
    SiteSection,
    GenerationLabel,
    Generation,
  },
  data: function () {
    return {
      activeGeneration: 2024,
      sprouters: {
        sprouters2024: sprouters2024,
        sprouters2023: sprouters2023,
        sprouters2022: sprouters2022,
        sprouters2021: sprouters2021,
        sprouters2020: sprouters2020,
        sprouters2019: sprouters2019,
        sprouters2018: sprouters2018,
        sprouters2017: sprouters2017,
        sprouters2016: sprouters2016,
        sprouters2015: sprouters2015,
        sprouters2014: sprouters2014,
      },
    };
  },
  methods: {
    isActive: function (generation) {
      if (generation == this.activeGeneration) {
        return true;
      }
      return false;
    },
    changeGeneration: function (generation) {
      this.activeGeneration = generation;
    },
  },
};
</script>

<style scoped
       lang="scss">
@import "../static/styles/palette.scss";

.label-container {
  display: flex;
  position: relative;
  z-index: 11;
  margin: -73px 10px 10px 430px;
  overflow-y: auto;
}
.section {
  padding-bottom: 80px;
}

@media all and (max-width: 960px) {
  .label-container {
    margin: 10px 10px 0 60px;
  }

  .section {
    padding-bottom: 0;
  }
}

@media all and (max-width: 768px) {
  .label-container {
    margin: 10px 10px 0 30px;
  }
}

@media all and (max-width: 480px) {
  .label-container {
    margin: 10px 20px 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// SectionTalking.vue?11a32b58